import SubtleBadge from '../../../../components/common/SubtleBadge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ChildrensTooltip from '../../../../components/common/ChildrensTooltip';
import { crawlTooltip } from '@/app/Crawl/tooltip/crawlTooltips';
// نمایش وضعیت خزش در تاریخچه خزش
type CrawlStatusRendererProps = {
  status?: number | null;
};

const CrawlStatusRenderer = ({ status }: CrawlStatusRendererProps) => {
  const statusEl = () => {
    switch (status) {
      case 13:
        return (
          <SubtleBadge
            pill
            bg="success"
            className="d-flex align-items-center gap-1 fs--2"
          >
            <FontAwesomeIcon icon="check" transform="shrink-2" />
            پایان (حذف داده)
            <ChildrensTooltip
              placement="top"
              showOnHover={false}
              delayToRemove={100}
              html={crawlTooltip.expiredCrawl}
            >
              <FontAwesomeIcon
                className="cursor-pointer"
                icon="exclamation-circle"
              />
            </ChildrensTooltip>
          </SubtleBadge>
        );
      case 2:
        return (
          <SubtleBadge
            pill
            bg="success"
            className="d-flex align-items-center gap-1 fs--2"
          >
            <FontAwesomeIcon icon="check" transform="shrink-2" />
            پایان (موفق)
          </SubtleBadge>
        );
      case 22:
        return (
          <SubtleBadge
            pill
            bg="success"
            className="d-flex align-items-center gap-1 fs--2"
          >
            <FontAwesomeIcon icon="check" transform="shrink-2" />
            پایان (اتمام بودجه)
          </SubtleBadge>
        );
      case 5:
        return (
          <SubtleBadge
            pill
            bg="warning"
            className="d-flex align-items-center gap-1  fs--2"
          >
            <FontAwesomeIcon icon="stream" transform="shrink-2" />
            درحال خزش
          </SubtleBadge>
        );
      case 3:
        return (
          <SubtleBadge
            pill
            bg="danger"
            className="d-flex align-items-center gap-1  fs--2"
          >
            <FontAwesomeIcon icon="ban" transform="shrink-2" />
            خطا
            <ChildrensTooltip
              placement="top"
              showOnHover={true}
              delayToRemove={200}
              html={crawlTooltip.errorCrawl}
            >
              <FontAwesomeIcon
                className="cursor-pointer"
                icon="exclamation-circle"
              />
            </ChildrensTooltip>
          </SubtleBadge>
        );
      case 48:
        return (
          <SubtleBadge
            pill
            bg="danger"
            className="d-flex align-items-center gap-1  fs--2"
          >
            <FontAwesomeIcon icon="ban" transform="shrink-2" />
            خطای timeout
            <ChildrensTooltip
              placement="top"
              showOnHover={true}
              delayToRemove={200}
              html={crawlTooltip.timeout}
            >
              <FontAwesomeIcon
                className="cursor-pointer"
                icon="exclamation-circle"
              />
            </ChildrensTooltip>
          </SubtleBadge>
        );
      case 43:
        return (
          <SubtleBadge
            pill
            bg="danger"
            className="d-flex align-items-center gap-1  fs--2"
          >
            <FontAwesomeIcon icon="ban" transform="shrink-2" />
            خطای عدم دسترسی
            <ChildrensTooltip
              placement="top"
              showOnHover={true}
              delayToRemove={200}
              html={crawlTooltip.timeout}
            >
              <FontAwesomeIcon
                className="cursor-pointer"
                icon="exclamation-circle"
              />
            </ChildrensTooltip>
          </SubtleBadge>
        );
      case 49:
        return (
          <SubtleBadge
            pill
            bg="danger"
            className="d-flex align-items-center gap-1  fs--2"
          >
            <FontAwesomeIcon icon="ban" transform="shrink-2" />
            خطای بلاک شدن خزش
          </SubtleBadge>
        );
      case 42:
        return (
          <SubtleBadge
            pill
            bg="danger"
            className="d-flex align-items-center gap-1  fs--2"
          >
            <FontAwesomeIcon icon="ban" transform="shrink-2" />
            خطای دسترسی
            <ChildrensTooltip
              placement="top"
              showOnHover={true}
              delayToRemove={200}
              html={crawlTooltip.timeout}
            >
              <FontAwesomeIcon
                className="cursor-pointer"
                icon="exclamation-circle"
              />
            </ChildrensTooltip>
          </SubtleBadge>
        );
      case 45:
        return (
          <SubtleBadge
            pill
            bg="danger"
            className="d-flex align-items-center gap-1  fs--2"
          >
            <FontAwesomeIcon icon="ban" transform="shrink-2" />
            خطا - محدودیت در robots.txt
          </SubtleBadge>
        );
      case 12:
        return (
          <SubtleBadge
            pill
            bg="success"
            className="d-flex align-items-center gap-1 fs--2"
          >
            <FontAwesomeIcon icon="ban" transform="shrink-2" />
            پایان اجباری (موفق)
          </SubtleBadge>
        );
      case 6:
        return (
          <SubtleBadge
            pill
            bg="secondary"
            className="d-flex align-items-center gap-1  fs--2"
          >
            <FontAwesomeIcon icon="times" transform="shrink-2" />
            نامشخص
          </SubtleBadge>
        );
      case 0:
        return (
          <SubtleBadge
            pill
            bg="info"
            className="d-flex align-items-center gap-1  fs--2"
          >
            <FontAwesomeIcon icon="stream" transform="shrink-2" />
            درصف خزش
          </SubtleBadge>
        );

      default:
        return <></>;
    }
  };
  return (
    <div className="w-100 d-flex h-100 align-items-center justify-content-center ">
      {statusEl()}
    </div>
  );
};

export default CrawlStatusRenderer;
